const HOME = -1;
const COMPLETED = 0;
const REMAINING = 1;
const HOME_TXT = 'Home';
const COMPLETED_TXT = 'Completed';
const REMAINING_TXT = 'Remaining';

export default {
  HOME,
  COMPLETED,
  REMAINING,
  HOME_TXT,
  COMPLETED_TXT,
  REMAINING_TXT,
};
